import React, { Component } from 'react';

import DateFnsUtils from '@date-io/date-fns';

import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from '@material-ui/pickers';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class WebProjectSmsTiming extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // SMS settings
      smsSendMode: "specificTime",
      smsSendSpecificTime: null,
      smsSendInterval: null,
      // Snackbar
      openSnackbar: false,
      snackbarMessage: null,
      snackbarVariant: Configs.snackbarVariants.info,
    };

    this.getSmsSettings();
  }

  render() {
    return (
      <Box maxWidth={800} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>SMS Timing</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Specific Time</Typography>
                <Typography variant="subtitle1">Send SMS at a specific time</Typography>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    fullWidth
                    id="time-picker"
                    label="SMS Time"
                    value={this.state.smsSendSpecificTime}
                    onChange={(time) => this.setState({ smsSendSpecificTime: time })}
                    disabled={this.state.smsSendMode !== "specificTime"}
                    margin="normal"
                  />
                </MuiPickersUtilsProvider>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    color="primary"
                    variant={this.state.smsSendMode === "specificTime" ? "contained" : "outlined"}
                    onClick={() => this.setState({ smsSendMode: "specificTime", smsSendSpecificTime: new Date(), smsSendInterval: null })}
                  >
                    {this.state.smsSendMode === "specificTime" ? "Enabled" : "Disabled"}
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Specific Interval</Typography>
                <Typography variant="subtitle1">Send out SMS at a set interval (8am-8pm)</Typography>
                <TextField
                  fullWidth
                  type="number"
                  label="SMS Interval"
                  value={this.state.smsSendInterval ?? ""}
                  onChange={(e) => this.setState({ smsSendInterval: e.target.value })}
                  disabled={this.state.smsSendMode !== "specificInterval"}
                  helperText="Minutes between sending SMS"
                  margin="normal"
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    color="primary"
                    variant={this.state.smsSendMode === "specificInterval" ? "contained" : "outlined"}
                    onClick={() => this.setState({ smsSendMode: "specificInterval", smsSendSpecificTime: null, smsSendInterval: "30" })}
                  >
                    {this.state.smsSendMode === "specificInterval" ? "Enabled" : "Disabled"}
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.setSmsSettings()}>
                {this.state.settingsIsSaving ? <CircularProgress color="inherit" size={20} /> : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }

  async getSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.getSmsSettings);
      const response = await api.post(["SendSMSFrequencyMinutes", "SendSMSFrequencyDailySchedule"]);
      const smsSendInterval = response["SendSMSFrequencyMinutes"];
      let smsSendSpecificTime = response["SendSMSFrequencyDailySchedule"];
      if (smsSendSpecificTime !== null && smsSendSpecificTime !== undefined) {
        const specificTime = new Date();
        specificTime.setHours(smsSendSpecificTime.split(":")[0]);
        specificTime.setMinutes(smsSendSpecificTime.split(":")[1]);
        smsSendSpecificTime = specificTime;
      }

      const smsSendMode = (smsSendInterval !== null && smsSendInterval !== undefined) ? "specificInterval" : "specificTime";
      this.setState({ smsSendInterval, smsSendSpecificTime, smsSendMode });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could get SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async setSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.setSmsSettings);
      this.setState({ settingsIsSaving: true });
      if (this.state.smsSendMode === "specificInterval") {
        await api.post({
          "SendSMSFrequencyMinutes": this.state.smsSendInterval,
          "SendSMSFrequencyDailySchedule": null,
        });

        this.setState({ snackbarMessage: "SMS settings saved successfully", snackbarVariant: "success", openSnackbar: true });
      } else if (this.state.smsSendMode === "specificTime") {
        const specificTime = new Date(this.state.smsSendSpecificTime);
        await api.post({
          "SendSMSFrequencyMinutes": null,
          "SendSMSFrequencyDailySchedule": specificTime.getHours() + ":" + specificTime.getMinutes(),
        });

        this.setState({ snackbarMessage: "SMS settings saved successfully", snackbarVariant: "success", openSnackbar: true });
      }
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could not save SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
    finally {
      this.setState({ settingsIsSaving: false });
    }
  }
}

export default WebProjectSmsTiming;
